(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["navbar-dropdown-item"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-kk-submenu-toggle]');
    if (!toggle) return;
    const submenu = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!submenu) return;
    event.preventDefault();
    event.stopPropagation();
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    submenu.hidden = expanded;
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const item = event.target.closest('li');
    const submenu = event.target.closest('.kk-submenu-list') || item?.querySelector('.kk-submenu-list:not([hidden])');
    if (!submenu || submenu.hidden) return;
    const toggle = submenu.parentElement.querySelector('[data-kk-submenu-toggle]');
    if (!toggle) return;
    event.preventDefault();
    event.stopPropagation();
    submenu.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.focus();
  }, true);

  document.addEventListener('hidden.bs.dropdown', (event) => {
    const menu = event.target.closest('.nav-item');
    if (!menu) return;
    menu.querySelectorAll('[data-kk-submenu-toggle]').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
      const submenu = document.getElementById(toggle.getAttribute('aria-controls'));
      if (submenu) submenu.hidden = true;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
